import { Form as AntForm } from 'antd';
import { FC, useState } from 'react';

import { NurseLicenseCompactDto } from '@clh/api-client';
import { useApiClient, useError } from '@clh/ui';

import { useFetchRecordContext } from '../hooks/use-fetch-record';
import { Modal } from '../modal';

import { Form } from './form';

export const Create: FC = () => {
    const [open, setOpen] = useState(false);
    const [form] = AntForm.useForm();
    const [error, setError] = useError();
    const api = useApiClient();
    const { fetchRecord } = useFetchRecordContext();

    function handleTarget() {
        form.resetFields();
        setOpen(true);
    }

    function handleOk() {
        form.submit();
    }

    async function handleFinish(nurseLicenseCompact: NurseLicenseCompactDto) {
        try {
            await api?.nurseLicenseCompactControllerCreateNurseLicenseCompact({
                nurseLicenseCompactDto: nurseLicenseCompact,
            });
            setOpen(false);
            await fetchRecord();
        } catch (e) {
            setError(e);
        }
    }

    return (
        <Modal
            open={open}
            title="Create New Nurse License Compact"
            onTarget={handleTarget}
            onOk={handleOk}
            onCancel={() => setOpen(false)}
        >
            <Form form={form} error={error} onFinish={void handleFinish} />
        </Modal>
    );
};
